// Module
var code = " <div class=\"ktable-settings\"> <div>TODO</div> </div> ";
// Exports
export default code;